<template>
  <div class="admin__container admin__container_wide">
    <div>
      <div style="display: flex; justify-content: space-between">
        <p style="font-size: 20px; font-weight: 500">Управление порядком игр</p>

        <v-btn color="primary" @click="openGameModal = true"> Добавить игру </v-btn>
      </div>
      <br>

      <v-tabs v-model="tab">
        <v-tabs-slider color="accent" />

        <v-tab v-for="title in tabTitles" :key="title">
          {{ title }}
        </v-tab>

        <v-tab-item>
          <v-data-table
            :items="games.slots"
            :headers="headers"
            :loading="loading"
            hide-actions
          >
            <template #items="props">
              <template v-for="header in headers">
                <td v-if="header.value === 'action'">
                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder(games.slots, 'up', props)"
                  >
                    <v-icon color="green">arrow_upward</v-icon>
                  </v-btn>

                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder(games.slots, 'down', props)"
                  >
                    <v-icon color="red">arrow_downward</v-icon>
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'weight_action'">
                  <v-text-field
                    v-model="props.item.weight_input"
                    color="accent"
                    style="max-width: 80px"
                    :rules="[rules.required, rules.weight(games.slots)]"
                  />
                </td>

                <td v-else-if="header.value === 'btn'">
                  <v-btn color="primary" :disabled="inputChanged(props.item, games.slots)" @click="saveGameOrder(props.item)">
                    Сохранить
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'delete'">
                  <v-btn
                    color="secondary"
                    small
                    fab
                    @click="openDeleteModal(props.item)"
                  >
                    <v-icon> delete </v-icon>
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'provider'">
                  {{ props.item.provider.public_name }}
                </td>

                <td v-else-if="header.value === 'name'">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <img
                      style="border-radius: 16px"
                      :src="props.item.image"
                      alt="game image"
                      width="80px"
                    >
                    {{ props.item.name }}
                  </div>
                </td>

                <td v-else>{{ props.item[header.value] }}</td>
              </template>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <v-data-table
            :items="games.live"
            :headers="headers"
            :loading="loading"
            hide-actions
          >
            <template #items="props">
              <template v-for="header in headers">
                <td v-if="header.value === 'action'">
                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder(games.live, 'up', props)"
                  >
                    <v-icon color="green">arrow_upward</v-icon>
                  </v-btn>

                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder(games.live, 'down', props)"
                  >
                    <v-icon color="red">arrow_downward</v-icon>
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'weight_action'">
                  <v-text-field
                    v-model="props.item.weight_input"
                    color="accent"
                    style="max-width: 80px"
                    :rules="[rules.required, rules.weight(games.live)]"
                  />
                </td>

                <td v-else-if="header.value === 'btn'">
                  <v-btn color="primary" :disabled="inputChanged(props.item, games.live)" @click="saveGameOrder(props.item)">
                    Сохранить
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'delete'">
                  <v-btn
                    color="secondary"
                    small
                    fab
                    @click="openDeleteModal(props.item)"
                  >
                    <v-icon> delete </v-icon>
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'provider'">
                  {{ props.item.provider.public_name }}
                </td>

                <td v-else-if="header.value === 'name'">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <img
                      style="border-radius: 16px"
                      :src="props.item.image"
                      alt="game image"
                      width="80px"
                    >
                    {{ props.item.name }}
                  </div>
                </td>

                <td v-else>{{ props.item[header.value] }}</td>
              </template>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </div>

    <div class="divider" :style="{ background: isThemeDark ? '#303030' : '#fafafa' }" />

    <div style="padding: 10px 0">
      <p style="font-size: 20px; font-weight: 500">Управление внешними играми</p>

      <v-checkbox v-model="softswissCheckbox" :label="`Softswiss`" style="margin-left: 10px" />

      <v-checkbox v-model="pragmaticCheckbox" :label="`Pragmatic`" style="margin-left: 10px" />

      <v-btn
        color="primary"
        :disabled="!softswissCheckbox && !pragmaticCheckbox"
        @click="onClick()"
      >
        Синхронизировать игры
      </v-btn>
    </div>

    <div class="divider" :style="{ background: isThemeDark ? '#303030' : '#fafafa' }" />

    <div style="padding: 10px 0">
      <v-list>
        <p style="font-size: 20px; font-weight: 500">Игры Casher</p>
        <br>
        <v-list-tile v-for="item in items" :key="item.title">
          <v-list-tile-title class="font-weight-light">{{ item.title }}</v-list-tile-title>
          <v-spacer />
          <v-switch
            v-model="item.status"
            class="games__show font-weight-light"
            :label="item.status ? 'Включен' : 'Отключен'"
            @change="changeGameStatus(item)"
          />
          <v-btn flat small :to="{ name: 'game', params: { game: item.editorId } }">Подробнее</v-btn>
        </v-list-tile>
      </v-list>
    </div>

    <v-snackbar v-model="localSnackbar" :color="success ? 'green' : 'red'">
      {{ snackbarText }}
    </v-snackbar>

    <v-dialog v-model="showDeleteModal" max-width="290">
      <v-card>
        <v-card-text class="dialog-title">Хотите удалить игру?</v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" flat="flat" @click="deleteGameFromTop"> Подтвердить </v-btn>

          <v-btn
            color="red darken-1"
            flat="flat"
            @click="
              () => {
                ;(currentGame = null), (showDeleteModal = false)
              }
            "
          >
            Отмена
          </v-btn>

          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <GameModal
      :dialog="openGameModal"
      :gameCounts="gameCounts"
      @update:localDialog="(val) => { openGameModal = val }"
      @createGame="createGame"
      @cancel="openGameModal = false"
    />
  </div>
</template>

<script>
import { startMines, stopMines } from '../../api/mines'
import { startWheel, stopWheel } from '../../api/wheel'
import {
  getGamesStatus, getGames, changeGamesOrder, deleteGame, syncSoftswissGames, syncPragmaticGames, syncProviders
} from '../../api/games'
import { startDice, stopDice } from '../../api/dice'
import { startCrash, stopCrash } from '../../api/crash'
import { startFrutto, stopFrutto } from '../../api/frutto'
import User from '../../helpers/user'
import GameModal from '@/components/modals/GameModal.vue'

export default {
  components: { GameModal },
  data: () => ({
    items: [
      {
        title: 'Wheel',
        key: 'wheel',
        editorId: 1,
        status: false,
        start: startWheel,
        stop: stopWheel
      },
      {
        title: 'Dice',
        key: 'dice',
        editorId: 2,
        status: false,
        start: startDice,
        stop: stopDice
      },
      {
        title: 'Mines',
        key: 'mines',
        editorId: 3,
        status: false,
        start: startMines,
        stop: stopMines
      },
      {
        title: 'Crash',
        key: 'crash',
        editorId: 4,
        status: false,
        start: startCrash,
        stop: stopCrash
      },
      {
        title: 'Frutto',
        key: 'frutto',
        editorId: 5,
        status: false,
        start: startFrutto,
        stop: stopFrutto
      }
    ],
    localSnackbar: false,
    snackbarText: '',
    success: true,
    softswissCheckbox: false,
    pragmaticCheckbox: false,
    showDeleteModal: false,
    openGameModal: false,
    currentGame: null,
    isThemeDark: JSON.parse(localStorage.getItem('isThemeDark')) || false,
    loading: false,
    tab: null,
    tabTitles: ['Слоты', 'Live казино'],
    games: {
      slots: [],
      live: []
    },
    headers: [
      {
        text: 'Позиция',
        value: 'weight',
        sortable: false
      },
      {
        text: 'Название',
        value: 'name',
        sortable: false
      },
      {
        text: 'Провайдер',
        value: 'provider',
        sortable: false
      },
      {
        text: 'Действие',
        value: 'action',
        sortable: false
      },
      {
        text: 'Номер позиции',
        value: 'weight_action',
        sortable: false
      },
      {
        text: 'Удалить',
        value: 'delete',
        sortable: false
      },
      {
        text: '',
        value: 'btn',
        sortable: false
      }
    ],
    rules: {
      required: value => !!value || 'Обязательное поле!',
      weight: arr => value => {
        const maxWeight = arr.reduce((prev, current) => (prev.weight > current.weight ? prev : current)).weight
        const regex = /^\d{1,2}$/
        if (!value || value < 1 || value > maxWeight) return `Введите число от 1 до ${maxWeight}`
        return regex.test(value) || 'Неверное значение!'
      }
    }
  }),
  computed: {
    gameCounts () {
      return {
        slots: this.games?.slots?.length || 0,
        live: this.games?.live?.length || 0
      }
    }
  },
  mounted () {
    EventBus.$on('theme-changed', e => (this.isThemeDark = e))
    getGamesStatus()
      .then(response => {
        this.items.forEach(item => {
          const tmp = response.data.find(i => i.name === item.key)
          item.status = tmp.status === 'enabled'
        })
      })
      .catch(error => {
        console.log(error)
      })

    this.fetchGames()
  },
  methods: {
    fetchGames () {
      try {
        this.loading = true
        getGames().then(response => {
          if (response.data.slots)
            this.games.slots = response.data.slots.map(item => ({ ...item, weight_input: item.weight }))
          if (response.data.live_casino)
            this.games.live = response.data.live_casino.map(item => ({ ...item, weight_input: item.weight }))
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async changeOrder (arr, direction, props) {
      if (!Array.isArray(arr)) return
      const targetIndex = direction === 'up' ? props.index - 1 : props.index + 1
      if (arr[targetIndex]) {
        try {
          this.loading = true
          await changeGamesOrder(props.item.id, { direction })
        } catch (error) {
          if (error.response.status === 403) alert('У вас недостаточно прав')
          else alert(`${error.response.data.message}. Попробуйте обновить страницу`)
        }
      } else {
        this.loading = false
        return
      }

      this.clear()
      this.fetchGames()
      this.loading = false
    },
    async saveGameOrder (item) {
      try {
        this.loading = true
        if (item.weight !== parseInt(item.weight_input)) await changeGamesOrder(item.id, { weight: parseInt(item.weight_input) })

        this.clear()
        this.fetchGames()
      } catch (error) {
        alert(`${error.response.data.message}. Попробуйте обновить страницу`)
      } finally {
        this.loading = false
      }
    },
    async deleteGameFromTop () {
      try {
        this.loading = true
        this.showDeleteModal = false
        if (this.currentGame) await deleteGame(this.currentGame.id)
        this.clear()
        this.fetchGames()
      } catch (error) {
        alert(`${error.response.data.message}. Попробуйте обновить страницу`)
      } finally {
        this.loading = false
      }
    },
    async createGame (e) {
      try {
        this.loading = true
        await changeGamesOrder(e.game.id, { weight: parseInt(e.weight) })
      } catch (error) {
        alert(`${error.response.data.message}. Попробуйте обновить страницу`)
      }

      this.clear()
      this.fetchGames()
      this.loading = false
    },
    openDeleteModal (item) {
      this.currentGame = item
      this.showDeleteModal = true
    },
    inputChanged (item, arr) {
      if (item.weight === parseInt(item.weight_input)) return true
      const maxWeight = arr.reduce((prev, current) => (prev.weight > current.weight ? prev : current)).weight
      return !(item.weight_input && parseInt(item.weight_input) > 0 && parseInt(item.weight_input) <= maxWeight)
    },
    onClick () {
      this.localSnackbar = true
      if (User.hasAdminAccess()) {
        const promises = []

        promises.push(syncProviders())

        if (this.softswissCheckbox)
          promises.push(syncSoftswissGames())

        if (this.pragmaticCheckbox)
          promises.push(syncPragmaticGames())

        Promise.all(promises)
          .then(() => {
            this.success = true
            this.snackbarText = 'Задача добавлена в очередь, ожидайте уведомление в телеграмм'
          })
          .catch(error => {
            this.success = false
            this.snackbarText = `${error.response.data.message}`
          })
          .finally(() => {
            this.pragmaticCheckbox = false
            this.softswissCheckbox = false
          })
      } else {
        this.success = false
        this.snackbarText = 'Доступно только для администратора'
      }
    },
    changeGameStatus (item) {
      if (item.status) item.start()
      else item.stop()
    },
    clear () {
      this.games.slots = []
      this.games.live = []
    }
  }
}
</script>

<style lang="scss">
.divider {
  width: 105%;
  height: 50px;
  margin-left: -18px;
}

.games__show .v-input--selection-controls {
  padding-top: 10px;
}

.dialog-title {
  font-size: 20px;
  text-align: center;
}
</style>
